// Component
const ModalMultiplePrice = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-multiple-price"*/ "@/app/views/main-view/_shared/_components/modals/modal-multiple-price/modal-multiple-price.vue"
	)

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
import { productMixins } from "@/app/mixins/modules/product-mixins.js"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js"

// Services
import productService from "@/app/services/main/product/product-service.js"

// Constants
import { STATUS_CODES, SUBSCRIPTION_PERIOD, PRODUCT_STATUS } from "@/app/constants/constants"

export default {
	name: "BundleSelectProduct",
	components: {
		ModalMultiplePrice,
	},
	mixins: [tableMixins, productMixins, toastMessageMixins],
	data() {
		return {
			subPeriod: SUBSCRIPTION_PERIOD,
			isAPILoading: true,
			doggyPackRoute: "",
			modalMultiplePriceContent: {},

			// table
			theads: [
				{ name: "", searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, hasBtn: true },
				{ name: "SKU", searchLabel: "f_sku", sortLabel: "sku", isDesc: false, hasSearch: true },
				{ name: "Image", searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false },
				{ name: "Name", searchLabel: "f_name", sortLabel: "name", isDesc: false, hasSearch: true },
				{
					name: "Type",
					searchLabel: "f_productTypeName",
					sortLabel: "productTypeId",
					isDesc: false,
					hasProductTypeSearch: true,
				},
				{
					name: "Brand",
					searchLabel: "f_brandName",
					sortLabel: "brandId",
					isDesc: false,
					hasBrandSearch: true,
				},
				{ name: "Price", searchLabel: "f_price", sortLabel: "price", isDesc: false, hasSearch: true },
				{ name: "Size", searchLabel: "f_size", sortLabel: "size", isDesc: false, hasSizeSearch: true },
				{ name: "Age", searchLabel: "f_age", sortLabel: "age", isDesc: false, hasAgeSearch: true },
				{ name: "Status", searchLabel: "f_status", sortLabel: "status", isDesc: false, hasStatusSearch: true },
				{ name: "Available Qty", searchLabel: "f_quantity", sortLabel: null, isDesc: false },
			],
			selectedProducts: [],
			// sorting
			desc: true,
			lowOnStockToggleCheckbox: false,
			onSaleToggleCheckBox: false,
			subscriptionToggleCheckbox: false,
			outOfStockToggleCheckbox: false,
		}
	},
	props: {
		isDashboard: {
			type: Boolean,
			default: false,
		},
		availableProducts: {
			type: Array,
			default: null,
		},
	},
	computed: {
		noSelectedProduct() {
			return this.selectedProducts.length === 0
		},
	},
	async created() {
		this.selectedProducts = this.availableProducts
		await this.getProductTypeList()
		await this.getSubscriptionPeriodList()
		this.getTableContent()
	},
	methods: {
		rowStyle(product) {
			const quantity = product.quantity ? product.quantity : 0
			const minStock = product.minStock ? product.minStock : 0
			const lowStock = quantity <= minStock

			return quantity === 0 ? "color: red;" : lowStock ? "color: orange;" : ""
		},
		statusStyle(productStatus) {
			return productStatus === PRODUCT_STATUS.ACTIVE ? "color:green" : "color: red;"
		},
		statusFormatter(status) {
			switch (status) {
				case PRODUCT_STATUS.ACTIVE:
					return "Active"
				case PRODUCT_STATUS.INACTIVE:
					return "Inactive"
				default:
					return ""
			}
		},
		getProductList(queryParams) {
			// search filters
			if (this.columnsFilter) {
				if (this.columnsFilter.f_sku) {
					queryParams["f_sku"] = this.columnsFilter.f_sku
				}
				if (this.columnsFilter.f_name) {
					queryParams["f_name"] = this.columnsFilter.f_name
				}
				if (this.columnsFilter.f_productTypeName) {
					queryParams["f_productTypeName"] = this.columnsFilter.f_productTypeName
				}
				if (this.columnsFilter.f_brandName) {
					queryParams["f_brandName"] = this.columnsFilter.f_brandName
				}
				if (this.columnsFilter.f_price) {
					queryParams["f_price"] = this.columnsFilter.f_price
				}
				if (this.columnsFilter.f_size) {
					queryParams["f_size"] = this.columnsFilter.f_size
				}
				if (this.columnsFilter.f_age) {
					queryParams["f_age"] = this.columnsFilter.f_age
				}
				if (this.subscriptionToggleCheckbox) {
					queryParams["f_subscriptionBundle"] = this.subscriptionToggleCheckbox
				}
				if (this.columnsFilter.f_status) {
					queryParams["f_status"] = this.columnsFilter.f_status
				}
				if (this.columnsFilter.f_description) {
					queryParams["f_description"] = this.columnsFilter.f_description
				}
				if (this.onSaleToggleCheckBox) {
					queryParams["f_onSale"] = this.onSaleToggleCheckBox
				}
				if (this.columnsFilter.f_lowStock) {
					queryParams["f_lowStock"] = this.lowOnStockToggleCheckbox
				}
				if (this.outOfStockToggleCheckbox) {
					queryParams["f_oufOfStock"] = this.outOfStockToggleCheckbox
				}
			}

			this.isAPILoading = true

			productService.getProducts(queryParams).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.tableContent = {
						tableData: res.data.data.map((dt) => {
							const isProductExist = this.selectedProducts.find((item) => item.id === dt.id)

							return {
								...dt,
								isSelected: isProductExist,
							}
						}),
						paginationData: res.data.pagination,
					}
					this.isAPILoading = false
				} else {
					this.showAPIErrorToast("Unable to fetch product list.", res)
					this.isAPILoading = false
				}
			})
		},
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page
			this.getProductList({ page, limit, sortBy, desc })
		},
		hasProductImage(productImage) {
			let image = require("@/assets/images/temporary/product-image.png")

			if (productImage) {
				image = productImage
			}

			return image
		},
		showMultiplePriceModal(product) {
			if (product.subscriptionBundle) {
				const { price: monthlyPrice, quarterlyPrice, yearlyPrice, name: productName } = product
				this.modalMultiplePriceContent = {
					name: productName,
					monthlyPrice,
					quarterlyPrice,
					yearlyPrice,
				}

				setTimeout(() => {
					this.$refs.modalMultiplePrice.show()
				}, 100)
			}
		},
		handleToggleCheckbox(product, event) {
			const ageList = { A: "Adult", P: "Puppy" }
			if (event.target.checked) {
				const processProduct = {
					id: product.id,
					name: product.name,
					price: product.price,
					cost: product.cost,
					costIncTax: product.costIncTax,
					brand: product.brand,
					productQuantity: null,
					imageUrl: product.imageUrl,
					productType: product.productType.name,
					isSubscription: product.subscriptionBundle,
					age: ageList[product.age] ? ageList[product.age] : "Adult/Puppy",
					onSale: product.onSale,
					salePrice: product.salePrice,
					isOutOfStock: product.quantity <= 0,
					isInactive: product.status === PRODUCT_STATUS.INACTIVE,
				}
				this.selectedProducts = [...this.selectedProducts, processProduct]
			} else {
				this.selectedProducts = this.selectedProducts.filter((dt) => dt.id !== product.id)
			}
		},
		async addSelectedProducts() {
			this.$emit("addSelectedProducts", this.selectedProducts)
		},
		clearSelected() {
			this.selectedProducts = []
			this.tableContent.tableData = this.tableContent.tableData.map((dt) => {
				return {
					...dt,
					isSelected: false,
				}
			})
		},
		handleFilterCheckbox(fieldname, event) {
			switch (fieldname) {
				case "f_lowStock":
					this.lowOnStockToggleCheckbox = !this.lowOnStockToggleCheckbox
					break
				case "f_onSale":
					this.onSaleToggleCheckBox = !this.onSaleToggleCheckBox
					break
				case "f_oufOfStock":
					this.outOfStockToggleCheckbox = !this.outOfStockToggleCheckbox
					break
				default:
					this.subscriptionToggleCheckbox = !this.subscriptionToggleCheckbox
					break
			}
			this.onFilter(fieldname, event)
		},
		goBackToAddDoggyPack(){
			const fullPath = this.$route.fullPath;
			if(fullPath && fullPath.includes("/add")){
				this.$router.push("/doggy-packs/add");
			} else {
				this.$router.go(-1);
			}
		},
	},
}
